<script>
import { IA_SUGGESTIONS_PENDING_BADGE } from '@modules/crm/constants/Text'

/**
 * spec-005/007 — alerta de sugestões de IA pendentes de curadoria.
 *
 * Domain-agnostic: usado no histórico de transcrições (CRM > Transcrições),
 * na tabela/kanban de Relacionamento e no Kanban de Leads. O caller decide o
 * escopo (reunião ou cliente) — este componente só recebe a contagem e emite
 * `revisar` ao ser clicado.
 */
export default {
  name: 'IaSuggestionsPendingBadge',
  props: {
    /**
     * Contagem de sugestões aguardando curadoria.
     * `null` = o backend NÃO conseguiu apurar (estado neutro, nunca "sem pendências");
     * `0` = apurado e sem fila.
     */
    pendentes: { type: Number, default: null },
  },
  data() {
    return {
      texts: IA_SUGGESTIONS_PENDING_BADGE,
    }
  },
  computed: {
    temPendentes() {
      return typeof this.pendentes === 'number' && this.pendentes > 0
    },
    indefinido() {
      return this.pendentes === null || this.pendentes === undefined
    },
    rotuloAria() {
      return this.texts.aria(this.pendentes)
    },
    tituloTooltip() {
      return this.texts.titulo(this.pendentes)
    },
  },
  methods: {
    onRevisar() {
      this.$emit('revisar')
    },
  },
}
</script>

<template>
  <!-- Sem pendências (ou indefinido): travessão discreto, igual às outras colunas vazias -->
  <span
    v-if="!temPendentes"
    class="az-text-secondary az-size-14"
    data-test="badge-vazio"
  >
    {{ indefinido ? texts.indefinido : texts.vazio }}
  </span>

  <!-- Com pendências: chip de atenção (warning-new, não danger) + contagem; hover
       mostra só o título + call-to-action, clique abre o painel de curadoria. -->
  <v-tooltip v-else bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        small
        class="ia-suggestions-pending-badge az-chip-inline-badge"
        :aria-label="rotuloAria"
        data-test="badge-alerta"
        v-bind="attrs"
        v-on="on"
        @click.stop="onRevisar"
      >
        <icon-svg name="warning" size="10" color="var(--warning-new)" class="mr-1" />
        <b class="ia-suggestions-pending-badge__count">{{ pendentes }}</b>
      </v-chip>
    </template>
    <span data-test="badge-tooltip">
      {{ tituloTooltip }}<br />
      <b>{{ texts.cliqueParaRevisar }}</b>
    </span>
  </v-tooltip>
</template>

<style lang="sass" scoped>
// Laranja de atenção do guia DS (--warning-new) — nunca alert/danger (vermelho).
// color-mix gera o tint de fundo a partir do token (mesmo padrão de
// jornada-servico-linha.vue), em vez de duplicar o hex do token aqui.
// Medidas (height/padding/font-size) vêm de `.az-chip-inline-badge`
// (src/design/aawz/az-chip.sass) — fonte única do padrão de badge inline,
// compartilhada com relationship-score-badge.vue (G-2 do verdict de design
// da spec-001).
.ia-suggestions-pending-badge
  cursor: pointer
  background: color-mix(in srgb, var(--warning-new) 20%, white) !important

  &__count
    color: var(--warning-new)
</style>
